import { render, staticRenderFns } from "./kiosk-settings.vue?vue&type=template&id=30c27f57&"
import script from "./kiosk-settings.vue?vue&type=script&lang=js&"
export * from "./kiosk-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./kiosk-settings.vue?vue&type=custom&index=0&blockType=route&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports